import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

// sessionStorage를 사용하도록 recoilPersist 설정
const { persistAtom } = recoilPersist({
  key: 'recoil-persist', // 저장된 데이터에 대한 키
  storage: sessionStorage, // sessionStorage에 저장
});

// 모니터링 테이블에서 선택한 디바이스 이름을 저장하는 Atom
export const selectedDeviceNameAtom = atom({
  key: "selectedDeviceName",
  default: null,
});

export const selectedCategoryAtom = atom({
  key: 'selectedCategory',
  default: [],
  effects_UNSTABLE: [persistAtom],
});